type RightArrowHeadProps = {
  width?: number | string;
  height?: number | string;
};

const RightArrowHead = ({ width, height }: RightArrowHeadProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={width || 13}
    height={height || 13}
    viewBox='0 0 13 13'
  >
    <path
      fillRule='evenodd'
      d='M11.293 7l-5.147 5.147a.5.5 0 1 0 .708.707l6-6a.5.5 0 0 0 0-.708l-6-6a.5.5 0 1 0-.708.708L11.293 6H.5a.5.5 0 1 0 0 1h10.793z'
    />
  </svg>
);

export default RightArrowHead;
